import React, { useEffect } from 'react'
import QuestionComponentProps from '../../Questions/question-component-props'
import { fireReactGAEvent } from '../Questions/utils'

const withQuestion = <P extends QuestionComponentProps>(
  WrappedComponent: React.ComponentType<P>
) => (props: QuestionComponentProps): JSX.Element => {
    useEffect(() => fireReactGAEvent({
      category: 'Application Form',
      action: 'Question Visible',
      label: `qst.${props.questionKey}`,
      nonInteraction: true
    }), [])

    useEffect(
      () => {
        window.scrollTo(0, 0)
      }, []
    )

    return <WrappedComponent {...props as P} />
  }

export default withQuestion
